import { Route as ReportRoutes } from "./reports";
export const REPORTS = ReportRoutes;

import { Route as SiteRoutes } from "./siteDetails";
export const SITEDETAILS = SiteRoutes;

export interface Link {
  href: string;
  label: any;
  isBeta?: boolean;
}

export enum InsightType {
  Insights = "insights",
  Monitoring = "monitoring",
}

// Analysis routes -> Insights and Monitoring
export const ANALYSIS = `/analysis`;
export const INSIGHTS = `/analysis/${InsightType.Insights}`;
export const MONITORING = `/analysis/${InsightType.Monitoring}`;
export const INSIGHT_EQUIPS = `/analysis/${InsightType.Insights}/:syncoId/:ruleId`;
export const MONITORING_EQUIPS = `/analysis/${InsightType.Monitoring}/:syncoId/:ruleId`;

// Actions routes
export const ACTIONS = "/actions";
export const ADD_ACTION = "/actions/add";
export const EDIT_ACTION = "/actions/:actionId/edit";
export const VIEW_ACTION = "/actions/:actionId";

// Site details routes
export const SITE_DETAILS = "/sitedetails";

// Admin routes
export const USER_PROFILE = "/profile";
export const USER_ADMIN = "/users";
export const GROUP_ADMIN = "/groups";

// Public routes
export const LOGIN = "/login";
export const FORGOT = "/forgot";
export const RESET = "/reset";

// Settins routes
export const SETTINGS_MONITORING = `/settings/${InsightType.Monitoring}`;
export const SETTINGS_INSIGHTS = `/settings/${InsightType.Insights}`;
